function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/** *****************************************************************************
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2019, 2025. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 ****************************************************************************** */
import React, { Component } from "react";
import PropTypes from "prop-types";
import autoBind from "react-autobind";
import { ChevronDown, WarningAlt } from "@carbon/react/icons";
import { InlineLoading } from "@carbon/react";
import { NestedFilterableDropdown } from "@console/cloud-pal-community/components/Basic";
import { FormattedHTMLMessage } from "react-intl";
import { xhrPromise } from "../../utils/xhr";
import { ErrorMessage, WarningMessage, InfoMessage } from "../../utils/react-util";
import { RefResolverSecretFields } from "./RefResolverSecretFields";
import vaultUtil from "../../utils/vault-util";
var SecretDialogFields = /*#__PURE__*/function (_Component) {
  function SecretDialogFields(props) {
    var _this;
    _classCallCheck(this, SecretDialogFields);
    _this = _callSuper(this, SecretDialogFields, [props]);
    _this.promises = {};
    _this.oldCumulativeState = "idle";
    _this.state = {
      provider: {
        state: "idle",
        value: _this.props.provider
      },
      region: {
        state: "idle",
        value: _this.props.region
      },
      resource_group: {
        state: "idle",
        value: _this.props.resource_group
      },
      instance: {
        state: "idle",
        value: _this.props.instance
      },
      group: {
        state: "idle",
        value: _this.props.group
      },
      subdir: {
        state: "idle",
        value: ""
      },
      subdirHelper: {
        state: "idle",
        value: ""
      },
      secret: {
        state: "idle",
        value: _this.props.secret
      },
      field: {
        state: "idle",
        value: _this.props.field
      },
      resource_group_name: {
        value: ""
      },
      toolcardType: undefined,
      showGroup: false,
      showSubdir: false,
      newInstance: false,
      showField: false,
      basePath: undefined
    };
    autoBind(_this);
    return _this;
  }
  _inherits(SecretDialogFields, _Component);
  return _createClass(SecretDialogFields, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.vaultEnabled) {
        if (prevProps.modalOpen !== this.props.modalOpen && this.props.modalOpen) {
          this.populateUIFields();
        }

        // Sync state with props
        var pairs = {};
        pairs = this.checkSync(pairs, "region", prevProps);
        pairs = this.checkSync(pairs, "resource_group", prevProps);
        pairs = this.checkSync(pairs, "provider", prevProps);
        pairs = this.checkSync(pairs, "instance", prevProps);
        pairs = this.checkSync(pairs, "group", prevProps);
        pairs = this.checkSync(pairs, "subdir", prevProps);
        pairs = this.checkSync(pairs, "subdirHelper", prevProps);
        pairs = this.checkSync(pairs, "secret", prevProps);
        pairs = this.checkSync(pairs, "field", prevProps);
        if (Object.keys(pairs).length > 0) {
          this.setMultipleFieldsValue(pairs);
        }
      }
      var cumulativeState = this.computeCumulativeState(this.state);
      if (cumulativeState !== this.oldCumulativeState) {
        this.oldCumulativeState = cumulativeState;
        if (this.props.onCumulativeStateChange) {
          this.props.onCumulativeStateChange(cumulativeState);
        }
      }
    }
  }, {
    key: "computeCumulativeState",
    value: function computeCumulativeState(state) {
      var fields = ["region", "resource_group", "provider", "instance", "group", "subdir", "subdirHelper", "secret", "field"];
      var cumulativeState = fields.find(function (fieldName) {
        return state[fieldName] && state[fieldName].state === "fetching";
      }) ? "fetching" : "idle";
      return cumulativeState;
    }
  }, {
    key: "checkSync",
    value: function checkSync(fieldNameValuePairs, field, prevProps) {
      // check whether field prop current vs previous has changed,
      // and whether current state differs from current prop,
      // and if so, add current prop value to fields that need sync.
      if (this.props[field] !== prevProps[field]) {
        if (this.state[field].value !== this.props[field]) {
          var newPairs = _objectSpread(_objectSpread({}, fieldNameValuePairs), {}, _defineProperty({}, field, this.props[field]));
          return newPairs;
        }
      }
      return fieldNameValuePairs;
    }
  }, {
    key: "populateUIFields",
    value: function populateUIFields() {
      this.fetchProviders();
    }
  }, {
    key: "onRegionChange",
    value: function onRegionChange(e) {
      var value = e.target ? e.target.value : e;
      this.setFieldValue("region", value, null, this.fetchInstances);
    }
  }, {
    key: "onResourceGroupChange",
    value: function onResourceGroupChange(e) {
      var _this2 = this;
      var value = e.target ? e.target.value : e;
      this.setFieldValue("resource_group", value, null, function () {
        var rg = _this2.state.resource_group.options && _this2.state.resource_group.options.find(function (r) {
          return r.value === value;
        });
        _this2.setFieldValue("resource_group_name", rg ? rg.name : "", null, _this2.fetchInstances);
      });
    }
  }, {
    key: "isCrnProvider",
    value: function isCrnProvider(value) {
      var _this$state$provider;
      var provider = value && ((_this$state$provider = this.state.provider) === null || _this$state$provider === void 0 || (_this$state$provider = _this$state$provider.options) === null || _this$state$provider === void 0 ? void 0 : _this$state$provider.find(function (item) {
        return item.value === value;
      }));
      return !!(provider && provider.id_type === "instance-crn");
    }
  }, {
    key: "getSecretType",
    value: function getSecretType(value) {
      var _this$state$secret;
      var secret = value && ((_this$state$secret = this.state.secret) === null || _this$state$secret === void 0 || (_this$state$secret = _this$state$secret.options) === null || _this$state$secret === void 0 ? void 0 : _this$state$secret.find(function (item) {
        return item.value === value;
      }));
      return secret === null || secret === void 0 ? void 0 : secret.secret_type;
    }
  }, {
    key: "getSecretCrn",
    value: function getSecretCrn(value) {
      var _this$state$provider2, _this$state$secret2;
      if (!this.isCrnProvider((_this$state$provider2 = this.state.provider) === null || _this$state$provider2 === void 0 ? void 0 : _this$state$provider2.value)) {
        return null;
      }
      var secret = value && ((_this$state$secret2 = this.state.secret) === null || _this$state$secret2 === void 0 || (_this$state$secret2 = _this$state$secret2.options) === null || _this$state$secret2 === void 0 ? void 0 : _this$state$secret2.find(function (item) {
        return item.value === value;
      }));
      return secret === null || secret === void 0 ? void 0 : secret.secret_crn;
    }
  }, {
    key: "onProviderChange",
    value: function onProviderChange(e) {
      var _this3 = this;
      var value = (e.target ? e.target.value : e) || "";
      var fields = ["region", "resource_group", "instance", "group", "subdir", "subdirHelper", "secret", "field"];
      this.cancelPromises(fields);
      var toolcardType;
      var showSubdir;
      var showGroup = value === vaultUtil.SM_PROVIDER_TYPE;
      if (value.startsWith("".concat(vaultUtil.TOOLCARD_PREFIX))) {
        toolcardType = value.substring("".concat(vaultUtil.TOOLCARD_PREFIX).length).split(":")[0];
        showGroup = [vaultUtil.HV_PROVIDER_TYPE, vaultUtil.SM_PROVIDER_TYPE, vaultUtil.REF_SM_PROVIDER_TYPE].includes(toolcardType);
        showSubdir = toolcardType === vaultUtil.HV_PROVIDER_TYPE;
      }
      this.setFieldValue("provider", value, _objectSpread({
        toolcardType: toolcardType,
        showGroup: showGroup,
        showSubdir: showSubdir,
        newInstance: false,
        showField: false
      }, this.getUpdatedState(fields, {
        state: "idle",
        error: "",
        info: ""
      })), function () {
        return _this3.setInitialSaveOptions(function () {
          if (!toolcardType) {
            _this3.fetchRegions();
            _this3.fetchResourceGroups();
          } else if (toolcardType === vaultUtil.SM_PROVIDER_TYPE) {
            // Always fetch SM groups even in save mode
            _this3.fetchToolcardGroups();
          } else if (toolcardType === vaultUtil.REF_SM_PROVIDER_TYPE) {
            _this3.fetchToolcardRefSm();
          } else if (toolcardType === vaultUtil.HV_PROVIDER_TYPE) {
            // always fetch hv subdirs even in save mode...
            _this3.fetchToolcardSubdirs();
          } else if (_this3.props.mode !== "save") {
            if (showGroup && !showSubdir) {
              _this3.fetchToolcardGroups();
            } else {
              _this3.fetchToolcardSecrets();
            }
          }
        });
      });
    }

    // In save mode set the initial values for group & secret
  }, {
    key: "setInitialSaveOptions",
    value: function setInitialSaveOptions(callback) {
      var _this4 = this;
      if (this.props.mode === "save") {
        if (this.state.toolcardType === vaultUtil.HV_PROVIDER_TYPE) {
          this.setFieldValue("subdir", this.state.basePath, {
            subdir: _objectSpread(_objectSpread({}, this.state.subdir), {}, {
              state: "idle",
              error: "",
              info: ""
            })
          }, function () {
            _this4.setFieldValue("group", _this4.props.toolchainName, {
              secret: _objectSpread(_objectSpread({}, _this4.state.secret), {}, {
                value: _this4.props.secretInputName
              })
            }, function () {
              _this4.setFieldValue("secret", _this4.props.secretInputName, null, callback);
            });
          });
        } else {
          var initialSecretName = this.props.keyCreationType === "gpg-key" ? this.props.secretInputName : this.props.toolchainName;
          this.setFieldValue("secret", initialSecretName, null, callback);
        }
      } else {
        callback();
      }
    }
  }, {
    key: "onInstanceChange",
    value: function onInstanceChange(e) {
      var _this5 = this;
      // note, value may be undefined if fetched instances is []
      var value = e && e.target ? e.target.value : e;
      if (this.state.newInstance && !value) {
        this.setInstanceError(this.props.i18n.messages.instanceError);
      } else {
        this.setFieldValue("instance", value, _objectSpread({
          showField: false
        }, this.getUpdatedState(["instance", "group", "secret", "field"], {
          state: "idle",
          error: ""
        })), function () {
          if (_this5.state.provider.value === vaultUtil.SM_PROVIDER_TYPE) {
            // Always fetch SM groups even in save mode
            _this5.fetchGroups();
          } else if (_this5.props.mode !== "save") {
            if (_this5.state.showGroup) {
              _this5.fetchGroups();
            } else {
              _this5.fetchSecrets();
            } // else in mode === save, secrets/group is an edit box, not a combo, so no options to fetch
          }
        });
      }
    }
  }, {
    key: "onSecretChange",
    value: function onSecretChange(e) {
      var _this6 = this;
      var value = e && e.target ? e.target.value : e;
      if (!value) {
        this.setSecretError(this.props.i18n.messages.requiredFieldError);
      } else {
        var _this$state$provider3;
        var secretType = this.getSecretType(value);
        var showField = !this.isCrnProvider((_this$state$provider3 = this.state.provider) === null || _this$state$provider3 === void 0 ? void 0 : _this$state$provider3.value) && this.props.mode !== "save" && ["kv", "service_credentials", "username_password"].includes(secretType);
        this.setFieldValue("secret", value, _objectSpread({
          showField: showField
        }, this.getUpdatedState(["secret", "field"], {
          state: "idle",
          error: ""
        })), function () {
          if (showField) {
            if (!_this6.state.toolcardType) {
              _this6.fetchFields();
            } else {
              _this6.fetchToolcardFields();
            }
          } else {
            _this6.setFieldValue("field", "");
          }
        });
      }
    }
  }, {
    key: "onFieldChange",
    value: function onFieldChange(e) {
      // Note, this is on change of combo "field", aka, kvKey
      // It is separate from this.props.onFieldChange outer callback Fn.
      var value = e && e.target ? e.target.value : e;
      this.setFieldValue("field", value, {
        field: _objectSpread(_objectSpread({}, this.state.field), {}, {
          state: "idle",
          error: ""
        })
      });
    }
  }, {
    key: "onNoListOrDenySecretChange",
    value: function onNoListOrDenySecretChange(e) {
      var value = e && e.target ? e.target.value : e;
      if (!value) {
        this.setFieldValue("secret", "", {
          secret: _objectSpread(_objectSpread({}, this.state.secret), {}, {
            state: "idle",
            error: this.props.i18n.messages.requiredFieldError
          })
        });
      } else {
        this.setFieldValue("secret", value, {
          secret: _objectSpread(_objectSpread({}, this.state.secret), {}, {
            state: "idle",
            error: ""
          })
        });
      }
    }
  }, {
    key: "onGroupChange",
    value: function onGroupChange(e) {
      var _this7 = this;
      var value = e && e.target ? e.target.value : e;
      if (!value) {
        this.setGroupError(this.props.i18n.messages.requiredFieldError);
      } else {
        this.setFieldValue("group", value, _objectSpread({
          showField: false
        }, this.getUpdatedState(["group", "secret", "field"], {
          state: "idle",
          error: ""
        })), function () {
          if (_this7.props.mode !== "save") {
            if (!_this7.state.toolcardType) {
              _this7.fetchSecrets();
            } else {
              _this7.fetchToolcardSecrets();
            }
          }
        });
      }
    }
  }, {
    key: "onNoListOrDenyGroupChange",
    value: function onNoListOrDenyGroupChange(e) {
      var value = e && e.target ? e.target.value : e;
      if (!value) {
        this.setFieldValue("group", "", {
          group: _objectSpread(_objectSpread({}, this.state.group), {}, {
            state: "idle",
            error: this.props.i18n.messages.requiredFieldError
          })
        });
      } else {
        this.setFieldValue("group", value, _objectSpread({}, this.getUpdatedState(["group", "secret", "field"], {
          state: "idle",
          error: ""
        })));
      }
    }
  }, {
    key: "onSubdirHelperChange",
    value: function onSubdirHelperChange(e) {
      var _this8 = this;
      var value = e && e.target ? e.target.value : e;
      this.setFieldValue("subdirHelper", value, _objectSpread({}, this.getUpdatedState(["subdirHelper", "group", "secret", "field"], {
        state: "idle",
        error: ""
      })), function () {
        _this8.onSubdirChange(value);
      });
    }
  }, {
    key: "onSubdirChange",
    value: function onSubdirChange(e) {
      var _this9 = this;
      var value = e && e.target ? e.target.value : e;
      var code;
      if (value && value.selectedItems) {
        if (value.selectedItems.length > 0) {
          code = value.selectedItems[0].code;
          value = value.selectedItems[0].value;
        } else {
          value = this.state.basePath;
          code = 200;
        }
      }
      if (!value || value && !value.startsWith(this.state.basePath)) {
        this.setFieldValue("subdir", this.state.basePath, _objectSpread({}, this.getUpdatedState(["subdir", "group", "secret", "field"], {
          state: "idle"
        })));
      } else if (code === 200) {
        this.setFieldValue("subdir", value, _objectSpread({
          noListOrDeny: false,
          subdir: _objectSpread(_objectSpread({}, this.state.subdir), {}, {
            readOnly: true,
            state: "idle",
            error: "",
            info: ""
          })
        }, this.getUpdatedState(["group", "secret", "field"], {
          state: "idle",
          error: "",
          info: ""
        })), function () {
          if (_this9.props.mode !== "save") {
            _this9.fetchToolcardGroups();
          }
        });
      } else {
        var translations = this.props.i18n.messages;
        var _secretName = this.state.secretSegment || this.state.group && this.state.group.value;
        var _fieldName = this.state.fieldSegment || this.state.secret && this.state.secret.value;
        if (this.state.applySubdirSegment) {
          value = "".concat(this.state.basePath, "/").concat(this.state.subdirSegment);
        } else if (value.length > this.state.basePath.length && !value.startsWith("".concat(this.state.basePath, "/"))) {
          value = "".concat(this.state.basePath, "/").concat(value.substring(this.state.basePath.length));
        }
        this.setFieldValue("subdir", value, {
          applySubdirSegment: false,
          subdirSegment: undefined,
          secretSegment: undefined,
          fieldSegment: undefined,
          subdir: _objectSpread(_objectSpread({}, this.state.subdir), {}, {
            readOnly: false,
            state: "idle",
            info: translations.subdirEdit
          })
        }, function () {
          _this9.setFieldValue("group", _secretName, {
            group: _objectSpread(_objectSpread({}, _this9.state.group), {}, {
              state: "idle"
            })
          }, function () {
            _this9.setFieldValue("secret", _fieldName, {
              secret: _objectSpread(_objectSpread({}, _this9.state.secret), {}, {
                state: "idle"
              })
            }, function () {
              if (_this9.props.mode !== "save") {
                // show group input instead of dropdown...
                // and deal same for field dropdown vs input
                _this9.setState({
                  noListOrDeny: true,
                  group: _objectSpread(_objectSpread({}, _this9.state.group), {}, {
                    info: translations.secretEdit
                  }),
                  secret: _objectSpread(_objectSpread({}, _this9.state.secret), {}, {
                    info: translations.fieldEdit
                  })
                });
              }
            });
          });
        });
      }
    }
  }, {
    key: "fetchRegions",
    value: function fetchRegions() {
      var _this0 = this;
      var fields = ["region", "instance", "group", "secret", "field"];
      this.cancelPromises(fields);
      var _this$props = this.props,
        accountContext = _this$props.accountContext,
        bssAccount = _this$props.bssAccount,
        envId = _this$props.envId;
      if (accountContext || bssAccount) {
        this.setState(this.getUpdatedState(fields, {
          state: "fetching",
          error: ""
        }));
        var type = this.state.provider.value === vaultUtil.KP_PROVIDER_TYPE ? "key-protect" : "secrets-manager";
        var regionUrl = "/devops/setup/api/v2/regions?type=".concat(type);
        var cancelObj = {
          cancel: false
        };
        this.promises.region = cancelObj;
        xhrPromise(regionUrl, {
          dataType: "json",
          method: "GET",
          env_id: envId,
          accountContext: accountContext,
          bssAccount: bssAccount
        }).then(function (result) {
          if (!cancelObj.cancel) {
            if (result.body) {
              var regions = result.body.sort(function (a, b) {
                return a.display_name.toLocaleLowerCase().localeCompare(b.display_name.toLocaleLowerCase());
              }).map(function (region) {
                return {
                  name: region.display_name,
                  value: region.id
                };
              });
              if (regions && regions.length > 0) {
                // Work out the initial value for the dropdown
                var value;

                // Try the value from the secretInput first
                var parsed = vaultUtil.parseValue(_this0.props.value);
                if (parsed && !parsed.toolcard) {
                  var found = regions.find(function (region) {
                    return region.value === parsed.region;
                  });
                  value = found && found.value;
                }
                if (!value) {
                  // Try the current value next
                  value = _this0.state.region.value;
                  if (!regions.find(function (region) {
                    return region.value === value;
                  })) {
                    // Current value not found - try the env region
                    value = _this0.props.envId && _this0.props.envId.split(":").pop();
                    if (!regions.find(function (region) {
                      return region.value === value;
                    })) {
                      // No luck - just use the first value
                      value = regions[0].value;
                    }
                  }
                }

                // Set the state and trigger a child fetch
                _this0.setState({
                  region: {
                    state: "idle",
                    options: regions,
                    value: value // Also set in callback - do here to avoid re-render
                  }
                }, function () {
                  return _this0.onRegionChange(value);
                });
              } else {
                _this0.setRegionError(_this0.props.i18n.messages.noRegions);
              }
            }
          }
        })["catch"](function (err) {
          if (!cancelObj.cancel) {
            _this0.setRegionError(_this0.props.i18n.messages.fetchRegionsError);
          }
        });
      } else {
        this.setState(this.getUpdatedState(fields, {
          state: "idle"
        }));
      }
    }
  }, {
    key: "fetchResourceGroups",
    value: function fetchResourceGroups() {
      var _this1 = this;
      var fields = ["resource_group", "instance", "group", "secret", "field"];
      this.cancelPromises(fields);
      var _this$props2 = this.props,
        accountContext = _this$props2.accountContext,
        bssAccount = _this$props2.bssAccount,
        envId = _this$props2.envId;
      if (accountContext || bssAccount) {
        this.setState(this.getUpdatedState(fields, {
          state: "fetching",
          error: ""
        }));
        var rgUrl = "/devops/setup/api/v2/resource_groups?";
        if (accountContext && bssAccount) {
          rgUrl += "account_context=".concat(accountContext, "&bss_account=").concat(bssAccount);
        } else if (accountContext && !bssAccount) {
          rgUrl += "account_context=".concat(accountContext);
        } else if (!accountContext && bssAccount) {
          rgUrl += "bss_account=".concat(bssAccount);
        }
        var cancelObj = {
          cancel: false
        };
        this.promises.resource_group = cancelObj;
        return xhrPromise(rgUrl, {
          dataType: "json",
          method: "GET",
          env_id: envId,
          accountContext: accountContext,
          bssAccount: bssAccount
        }).then(function (result) {
          if (!cancelObj.cancel) {
            if (result.body.resources) {
              var resourceGroups = result.body.resources.sort(function (a, b) {
                return a.name.toLocaleLowerCase().localeCompare(b.name.toLocaleLowerCase());
              });
              var defaultResourceGroup = resourceGroups.find(function (rg) {
                return rg.id === window.localStorage["otc-ui.selected_rg"];
              });
              var filteredResourceGroups = resourceGroups.map(function (rg) {
                return {
                  value: rg.id,
                  name: rg.name
                };
              });
              if (resourceGroups && resourceGroups.length > 0) {
                // Work out the initial value for the dropdown
                var value;

                // Try the value from the secretInput first
                var parsed = vaultUtil.parseValue(_this1.props.value);
                if (parsed && !parsed.toolcard) {
                  var found = resourceGroups.find(function (rg) {
                    return rg.name === parsed.resource_group;
                  });
                  value = found && found.value;
                }
                if (!value) {
                  // Try the current value next
                  value = _this1.state.resource_group.value;
                  if (!resourceGroups.find(function (rg) {
                    return rg.id === value;
                  })) {
                    // Current value not found - use default or the first in the list
                    value = defaultResourceGroup && defaultResourceGroup.id || filteredResourceGroups[0] && filteredResourceGroups[0].value;
                  }
                }

                // Set the state and trigger a child fetch
                _this1.setState({
                  resource_group: {
                    state: "idle",
                    options: filteredResourceGroups,
                    value: value // Also set in callback - do here to avoid re-render
                  }
                }, function () {
                  return _this1.onResourceGroupChange(value);
                });
              } else {
                _this1.setResourceGroupError(_this1.props.i18n.messages.noResourceGroups);
              }
            }
          }
        })["catch"](function (err) {
          if (!cancelObj.cancel) {
            _this1.setResourceGroupError(_this1.props.i18n.messages.fetchResourceGroupsError);
          }
        });
      }
      this.setState(this.getUpdatedState(fields, {
        state: "idle"
      }));
    }
  }, {
    key: "fetchProviders",
    value: function fetchProviders() {
      var _this10 = this;
      var fields = ["provider", "region", "resource_goup", "instance", "group", "subdir", "subdirHelper", "secret", "field"];
      this.cancelPromises(fields);
      var _this$props3 = this.props,
        envId = _this$props3.envId,
        accountContext = _this$props3.accountContext,
        bssAccount = _this$props3.bssAccount,
        toolchainId = _this$props3.toolchainId;
      this.setState(this.getUpdatedState(fields, {
        state: "fetching",
        error: ""
      }));
      this.props.updateModalState && this.props.updateModalState({
        noIntegrations: false
      });
      var cancelObj = {
        cancel: false
      };
      this.promises.provider = cancelObj;
      var params = this.props.enableSmProvider ? "?enable_sm_provider=true" : "";
      xhrPromise("".concat(vaultUtil.SECRETS_API_PATH, "/providers").concat(params), {
        dataType: "json",
        method: "GET",
        env_id: envId,
        accountContext: accountContext,
        bssAccount: bssAccount,
        toolchainId: toolchainId,
        headers: _objectSpread({}, toolchainId ? {} : {
          "vti-instances": JSON.stringify(this.props.vaultIntegrations || [])
        })
      }).then(function (result) {
        if (!cancelObj.cancel) {
          if (result.body.providers) {
            var nonToolcardTypes = [vaultUtil.KP_PROVIDER_TYPE, vaultUtil.SM_PROVIDER_TYPE];
            var providers = result.body.providers.filter(function (provider) {
              if (provider.supported) {
                if (provider.type.startsWith(vaultUtil.TOOLCARD_PREFIX)) {
                  // Always show Toolcard providers
                  return true;
                }
                if (_this10.props.onlyVtiProviders === true) {
                  // Setup wizard mode - Service providers disabled
                  return false;
                }
                if (!toolchainId) {
                  // Setup normal mode - show service providers
                  return true;
                }
              }
              return false;
            }).map(function (provider) {
              return {
                value: provider.type,
                name: provider.display_name,
                id_type: provider.id_type,
                crn: provider.crn
              };
            }).flatMap(function (provider) {
              if (provider.value.startsWith("".concat(vaultUtil.TOOLCARD_PREFIX).concat(vaultUtil.SM_PROVIDER_TYPE, ":")) && provider.id_type !== "instance-crn" && _this10.props.toolchainId && _this10.props.bssAccount && _this10.props.envId && !_this10.props.onCreateAPIKey // fn is passed to minter dialog
              ) {
                // then
                // change from:
                //   toolcard-sm:sm1 | Secrets Manager: sm1
                // change to multiple entries:
                //   toolcard-ref-sm:sm1 | Secrets Manager: sm1
                //   toolcard-sm:sm1     | Secrets Manager: sm1 (legacy UI)
                // and use
                //   <RefResolverSecretFields
                // and legacy has UI label:
                //   (Using legacy dialog for secret selection)
                // smToolcardUiMode: sm-classic | sm-legacy | sm-ref
                // sm-classic (default when absent), old, without legacy label
                // sm-legacy, old, with label indicating legacy
                // sm-ref, new ref:// support
                var toolcardName = provider.value.split(":").pop();
                var refSmProvider = {
                  value: "".concat(vaultUtil.TOOLCARD_PREFIX).concat(vaultUtil.REF_SM_PROVIDER_TYPE, ":").concat(toolcardName),
                  name: provider.name,
                  toolcardName: toolcardName,
                  smToolcardUiMode: "sm-ref"
                };
                // TODO translate string
                var legacyProvider = {
                  value: provider.value,
                  name: "".concat(provider.name, " (legacy UI)"),
                  smToolcardUiMode: "sm-legacy"
                };
                // 2 provider options instead of 1.
                return [refSmProvider, legacyProvider];
              }
              // else, default, single Secrets Manager option for that toolcard.
              return provider;
            }).sort(function (a, b) {
              // Ensure non toolcards are at the end
              if (!(nonToolcardTypes.includes(a.value) && nonToolcardTypes.includes(b.value))) {
                if (nonToolcardTypes.includes(a.value)) {
                  return 1;
                }
                if (nonToolcardTypes.includes(b.value)) {
                  return -1;
                }
              }
              return a.name.toLocaleLowerCase().localeCompare(b.name.toLocaleLowerCase());
            });
            if (providers && providers.length > 0) {
              // Work out the initial value for the dropdown
              var value;

              // Try the value from the secretInput first
              var parsed = vaultUtil.parseValue(_this10.props.value);
              if (parsed) {
                var found = providers.find(function (provider) {
                  if (parsed.toolcard) {
                    if (parsed.provider === vaultUtil.CRN_PROVIDER_TYPE) {
                      return provider.id_type === "instance-crn" && parsed.instanceCrn === provider.crn;
                    }
                    return provider.value === "".concat(vaultUtil.TOOLCARD_PREFIX).concat(vaultUtil.KP_REFERENCE_TYPE, ":").concat(parsed.toolcardName) || provider.value === "".concat(vaultUtil.TOOLCARD_PREFIX).concat(vaultUtil.HV_REFERENCE_TYPE, ":").concat(parsed.toolcardName) || provider.value === "".concat(vaultUtil.TOOLCARD_PREFIX).concat(vaultUtil.SM_REFERENCE_TYPE, ":").concat(parsed.toolcardName);
                  }
                  return provider.value === parsed.provider;
                });
                value = found && found.value;
              }
              if (!value) {
                // Try the current value next
                value = _this10.state.provider.value;
                if (!providers.find(function (item) {
                  return item.value === value;
                })) {
                  // Current value not found - use the first in the list
                  value = providers[0] && providers[0].value;
                }
              }

              // Set the state and trigger a child fetch
              _this10.setState({
                provider: {
                  state: "idle",
                  options: providers,
                  value: value // Also set in callback - do here to avoid re-render
                }
              }, function () {
                return _this10.onProviderChange(value);
              });
            } else {
              _this10.props.updateModalState && _this10.props.updateModalState({
                noIntegrations: true
              });
            }
          }
        }
      })["catch"](function (err) {
        if (!cancelObj.cancel) {
          _this10.setProviderError(_this10.props.i18n.messages.fetchProvidersError);
        }
      });
    }
  }, {
    key: "fetchInstances",
    value: function fetchInstances() {
      var _this11 = this;
      var fields = ["instance", "group", "secret", "field"];
      this.cancelPromises(fields);
      if (this.state.region.state === "fetching" || this.state.resource_group.state === "fetching") {
        return;
      }
      var provider = this.state.provider.value;
      var region = this.state.region.value;
      var resource_group_id = this.state.resource_group.value;
      var _this$props4 = this.props,
        envId = _this$props4.envId,
        accountContext = _this$props4.accountContext,
        bssAccount = _this$props4.bssAccount,
        toolchainId = _this$props4.toolchainId;
      if (region && resource_group_id && provider) {
        this.setState(this.getUpdatedState(fields, {
          state: "fetching",
          error: ""
        }));
        var params = "?region=".concat(region, "&resource_group_id=").concat(resource_group_id);
        var cancelObj = {
          cancel: false
        };
        this.promises.instance = cancelObj;
        xhrPromise("".concat(vaultUtil.SECRETS_API_PATH, "/providers/").concat(provider).concat(params), {
          dataType: "json",
          method: "GET",
          env_id: envId,
          accountContext: accountContext,
          bssAccount: bssAccount,
          toolchainId: toolchainId
        }).then(function (result) {
          if (!cancelObj.cancel) {
            if (result.body.providers && result.body.providers[0] && result.body.providers[0].instances) {
              var instances = result.body.providers[0].instances.map(function (instance) {
                return {
                  value: instance.name,
                  name: instance.name
                };
              }).sort(function (a, b) {
                return a.name.toLocaleLowerCase().localeCompare(b.name.toLocaleLowerCase());
              });
              if (instances && instances.length > 0) {
                // Work out the initial value for the dropdown
                var value;

                // Try the value from the secretInput first
                var parsed = vaultUtil.parseValue(_this11.props.value);
                if (parsed && !parsed.toolcard) {
                  var found = instances.find(function (instance) {
                    return instance.value === parsed.instance;
                  });
                  value = found && found.value;
                }
                if (!value) {
                  // Try the current value next
                  value = _this11.state.instance.value;
                  if (!instances.find(function (i) {
                    return i.value === value;
                  })) {
                    // Current value not found - use the first in the list
                    value = instances[0] && instances[0].value;
                  }
                }

                // Set the state and trigger a child fetch
                _this11.props.onFieldChange("createNewInstance", false, _this11.hasError());
                _this11.setState({
                  newInstance: false,
                  instance: {
                    state: "idle",
                    options: instances,
                    value: value // Also set in callback - do here to avoid re-render
                  }
                }, function () {
                  return _this11.onInstanceChange(value);
                });
              } else if (_this11.state.provider.value === vaultUtil.KP_REFERENCE_TYPE || _this11.props.mode === "retrieve") {
                _this11.props.onFieldChange("createNewInstance", true, _this11.hasError());
                _this11.setState({
                  instance: _objectSpread(_objectSpread({}, _this11.state.instance), {}, {
                    state: "idle"
                  }),
                  newInstance: true
                }, function () {
                  return _this11.onInstanceChange("");
                });
              } else {
                // In save mode don't give the user the ability to create a new sm instance
                _this11.setInstanceError(_this11.props.i18n.messages.noInstances);
              }
            }
          }
        })["catch"](function (err) {
          if (!cancelObj.cancel) {
            _this11.setInstanceError(_this11.props.i18n.messages.fetchInstancesError);
          }
        });
      } else {
        this.setState(this.getUpdatedState(fields, {
          state: "idle"
        }));
      }
    }
  }, {
    key: "fetchGroups",
    value: function fetchGroups() {
      var _this12 = this;
      var fields = ["group", "secret", "field"];
      this.cancelPromises(fields);
      var region = this.state.region.value;
      var resource_group_id = this.state.resource_group.value;
      var provider = this.state.provider.value;
      var instance = this.state.instance.value;
      var _this$props5 = this.props,
        envId = _this$props5.envId,
        accountContext = _this$props5.accountContext,
        bssAccount = _this$props5.bssAccount,
        toolchainId = _this$props5.toolchainId;
      if (region && resource_group_id && provider && instance) {
        this.setState(this.getUpdatedState(fields, {
          state: "fetching",
          error: ""
        }));
        var params = "?region=".concat(region, "&resource_group_id=").concat(resource_group_id);
        var cancelObj = {
          cancel: false
        };
        this.promises.group = cancelObj;
        xhrPromise("".concat(vaultUtil.SECRETS_API_PATH, "/providers/").concat(provider, "/").concat(instance, "/groups").concat(params), {
          dataType: "json",
          method: "GET",
          env_id: envId,
          accountContext: accountContext,
          bssAccount: bssAccount,
          toolchainId: toolchainId
        }).then(function (result) {
          if (!cancelObj.cancel) {
            if (result.body.providers && result.body.providers[0] && result.body.providers[0].instances && result.body.providers[0].instances[0] && result.body.providers[0].instances[0].groups) {
              var groups = result.body.providers[0].instances[0].groups.map(function (group) {
                return {
                  value: group.name,
                  name: group.name
                };
              }).sort(function (a, b) {
                return a.name.toLocaleLowerCase().localeCompare(b.name.toLocaleLowerCase());
              });
              if (groups && groups.length > 0) {
                // Work out the initial value for the dropdown
                var value;

                // Try the value from the secretInput first
                var parsed = vaultUtil.parseValue(_this12.props.value);
                if (parsed && !parsed.toolcard) {
                  var found = groups.find(function (group) {
                    return group.value === parsed.group;
                  });
                  value = found && found.value;
                }
                if (!value) {
                  // Try the current value next
                  value = _this12.state.group.value;
                  if (!groups.find(function (s) {
                    return s.value === value;
                  })) {
                    value = groups[0] && groups[0].value;
                  }
                }

                // Set the state and trigger a child fetch
                _this12.setState({
                  group: {
                    state: "idle",
                    options: groups,
                    value: value // Also set in callback - do here to avoid re-render
                  }
                }, function () {
                  return _this12.onGroupChange(value);
                });
              } else {
                _this12.setGroupError(_this12.props.i18n.messages.noGroups);
              }
            } else {
              throw new Error();
            }
          }
        })["catch"](function (err) {
          if (!cancelObj.cancel) {
            _this12.setGroupError(_this12.props.i18n.messages.fetchGroupsError);
          }
        });
      } else {
        this.setState(this.getUpdatedState(fields, {
          state: "idle"
        }));
      }
    }
  }, {
    key: "fetchSecrets",
    value: function fetchSecrets() {
      var _this13 = this;
      var fields = ["secret", "field"];
      this.cancelPromises(fields);
      var region = this.state.region.value;
      var resource_group_id = this.state.resource_group.value;
      var provider = this.state.provider.value;
      var instance = this.state.instance.value;
      var group = this.state.group.value;
      var _this$props6 = this.props,
        envId = _this$props6.envId,
        accountContext = _this$props6.accountContext,
        bssAccount = _this$props6.bssAccount,
        toolchainId = _this$props6.toolchainId;
      if (region && resource_group_id && provider && instance && (!this.state.showGroup || group)) {
        this.setState(this.getUpdatedState(fields, {
          state: "fetching",
          error: ""
        }));
        var params = "?region=".concat(region, "&resource_group_id=").concat(resource_group_id);
        var cancelObj = {
          cancel: false
        };
        this.promises.secret = cancelObj;
        var url;
        if (this.state.showGroup) {
          params += "&list_sm_iam_creds=list&list_sm_kv=list";
          url = "".concat(vaultUtil.SECRETS_API_PATH, "/providers/").concat(provider, "/").concat(instance, "/groups/").concat(group).concat(params);
        } else {
          url = "".concat(vaultUtil.SECRETS_API_PATH, "/providers/").concat(provider, "/").concat(instance).concat(params);
        }
        xhrPromise(url, {
          dataType: "json",
          method: "GET",
          env_id: envId,
          accountContext: accountContext,
          bssAccount: bssAccount,
          toolchainId: toolchainId
        }).then(function (result) {
          if (!cancelObj.cancel) {
            var secrets;
            if (_this13.state.showGroup) {
              secrets = result.body.providers && result.body.providers[0] && result.body.providers[0].instances && result.body.providers[0].instances[0] && result.body.providers[0].instances[0].groups && result.body.providers[0].instances[0].groups[0] && result.body.providers[0].instances[0].groups[0].secrets;
            } else {
              secrets = result.body.providers && result.body.providers[0] && result.body.providers[0].instances && result.body.providers[0].instances[0] && result.body.providers[0].instances[0].secrets;
            }
            if (secrets) {
              secrets = secrets.map(function (secret) {
                if (secret.name && secret.secret_type) {
                  return {
                    value: secret.name,
                    name: secret.name,
                    secret_type: secret.secret_type,
                    secret_crn: secret.crn
                  };
                }
                return {
                  value: secret.name,
                  name: secret.name
                };
              }).sort(function (a, b) {
                return a.name.toLocaleLowerCase().localeCompare(b.name.toLocaleLowerCase());
              });
              if (secrets && secrets.length > 0) {
                // Work out the initial value for the dropdown
                var value;

                // Try the value from the secretInput first
                var parsed = vaultUtil.parseValue(_this13.props.value);
                if (parsed && !parsed.toolcard) {
                  var found = secrets.find(function (secret) {
                    return secret.value === parsed.secret;
                  });
                  value = found && found.value;
                }
                if (!value) {
                  // Try the current value next
                  value = _this13.state.secret.value;
                  var _found = secrets.find(function (secret) {
                    return secret.value === value;
                  });
                  if (!_found) {
                    value = secrets[0] && secrets[0].value;
                  }
                }

                // Set the state and trigger a child fetch
                _this13.setState({
                  secret: {
                    state: "idle",
                    options: secrets,
                    value: value // Also set in callback - do here to avoid re-render
                  }
                }, function () {
                  return _this13.onSecretChange(value);
                });
              } else {
                _this13.setSecretError(_this13.props.i18n.messages.noSecrets);
              }
            }
          }
        })["catch"](function (err) {
          if (!cancelObj.cancel) {
            _this13.setSecretError(_this13.props.i18n.messages.fetchSecretsError);
          }
        });
      } else {
        this.setState(this.getUpdatedState(fields, {
          state: "idle"
        }));
      }
    }
  }, {
    key: "fetchFields",
    value: function fetchFields() {
      var _this14 = this;
      var fields = ["field"];
      this.cancelPromises(fields);
      var region = this.state.region.value;
      var resource_group_id = this.state.resource_group.value;
      var provider = this.state.provider.value;
      var instance = this.state.instance.value;
      var group = this.state.group.value;
      var secret = this.state.secret.value;
      var _this$props7 = this.props,
        envId = _this$props7.envId,
        accountContext = _this$props7.accountContext,
        bssAccount = _this$props7.bssAccount,
        toolchainId = _this$props7.toolchainId;
      if (region && resource_group_id && provider && instance && group && secret) {
        this.setState(this.getUpdatedState(fields, {
          state: "fetching",
          error: ""
        }));
        var params = "?region=".concat(region, "&resource_group_id=").concat(resource_group_id);
        var cancelObj = {
          cancel: false
        };
        this.promises.field = cancelObj;
        var url;
        params += "&list_sm_iam_creds=list&list_sm_kv=list";
        url = "".concat(vaultUtil.SECRETS_API_PATH, "/providers/").concat(provider, "/").concat(instance, "/groups/").concat(group, "/secrets/").concat(secret, "/fields").concat(params);
        xhrPromise(url, {
          dataType: "json",
          method: "GET",
          env_id: envId,
          accountContext: accountContext,
          bssAccount: bssAccount,
          toolchainId: toolchainId
        }).then(function (result) {
          if (!cancelObj.cancel) {
            var _result$body;
            var _fields = result === null || result === void 0 || (_result$body = result.body) === null || _result$body === void 0 || (_result$body = _result$body.providers[0]) === null || _result$body === void 0 || (_result$body = _result$body.instances[0]) === null || _result$body === void 0 || (_result$body = _result$body.groups[0]) === null || _result$body === void 0 || (_result$body = _result$body.secrets[0]) === null || _result$body === void 0 ? void 0 : _result$body.fields;
            if (_fields) {
              _fields = _fields.map(function (field) {
                return {
                  value: field,
                  name: field
                };
              }).sort(function (a, b) {
                return a.name.toLocaleLowerCase().localeCompare(b.name.toLocaleLowerCase());
              });
              if (_fields && _fields.length > 0) {
                // Work out the initial value for the dropdown
                var value;

                // Add the entire secret option
                _fields.unshift({
                  value: "",
                  name: _this14.props.i18n.messages.entireSecret
                });

                // Try the value from the secretInput first
                var parsed = vaultUtil.parseValue(_this14.props.value);
                if (parsed && !parsed.toolcard) {
                  var found = _fields.find(function (field) {
                    return field.value === parsed.field;
                  });
                  value = found && found.value;
                }
                if (!value) {
                  // Try the current value next
                  value = _this14.state.field.value;
                  var _found2 = _fields.find(function (field) {
                    return field.value === value;
                  });
                  if (!_found2) {
                    value = _fields[0] && _fields[0].value;
                  }
                }

                // Set the state and trigger a child fetch
                _this14.setState({
                  field: {
                    state: "idle",
                    options: _fields,
                    value: value // Also set in callback - do here to avoid re-render
                  }
                }, function () {
                  return _this14.onFieldChange(value);
                });
              } else {
                _this14.setFieldError(_this14.props.i18n.messages.noKeys);
              }
            }
          }
        })["catch"](function (err) {
          if (!cancelObj.cancel) {
            _this14.setFieldError(_this14.props.i18n.messages.fetchKeysError);
          }
        });
      } else {
        this.setState(this.getUpdatedState(fields, {
          state: "idle"
        }));
      }
    }
  }, {
    key: "createFetchPartialPromise",
    value: function createFetchPartialPromise(partialReference) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$listSubdirs = _ref.listSubdirs,
        listSubdirs = _ref$listSubdirs === void 0 ? false : _ref$listSubdirs,
        _ref$listSmIamCreds = _ref.listSmIamCreds,
        listSmIamCreds = _ref$listSmIamCreds === void 0 ? false : _ref$listSmIamCreds,
        _ref$listKv = _ref.listKv,
        listKv = _ref$listKv === void 0 ? false : _ref$listKv;
      // fetch toolcard secret options
      // `http://localhost:3000/devops/api/v1/secrets?reference={vault::tmg-vault-service}&action=list`
      var params = "?reference=".concat(partialReference, "&action=").concat(!listSubdirs ? "list" : "listsubdirs");
      if (listSmIamCreds) {
        params += "&list_sm_iam_creds=list";
      }
      if (listKv) {
        params += "&list_sm_kv=list";
      }
      var _this$props8 = this.props,
        envId = _this$props8.envId,
        accountContext = _this$props8.accountContext,
        bssAccount = _this$props8.bssAccount,
        toolchainId = _this$props8.toolchainId;
      var promise = xhrPromise(vaultUtil.SECRETS_API_PATH + params, {
        dataType: "json",
        method: "GET",
        env_id: envId,
        accountContext: accountContext,
        bssAccount: bssAccount,
        toolchainId: toolchainId,
        headers: _objectSpread({}, toolchainId ? {} : {
          "vti-instances": JSON.stringify(this.props.vaultIntegrations || [])
        })
      });
      return promise;
    }
  }, {
    key: "fetchToolcardGroups",
    value: function fetchToolcardGroups() {
      var _this$state$provider4,
        _this15 = this;
      var translations = this.props.i18n.messages;
      var fields = ["region", "resource_group", "instance", "subdir", "subdirHelper"];
      var fetchFields = ["group", "secret", "field"];
      this.cancelPromises([].concat(fields, fetchFields));
      this.setState(_objectSpread(_objectSpread({}, this.getUpdatedState(fields, {
        state: "idle",
        error: ""
      })), this.getUpdatedState(fetchFields, {
        state: "fetching",
        error: ""
      })));
      var cancelObj = {
        cancel: false
      };
      this.promises.group = cancelObj;
      var toolcardName = this.state.provider.value.split(":").pop();
      var partialReference;
      if (this.state.showSubdir && this.state.subdir && this.state.subdir.value && this.state.subdir.value !== this.state.basePath) {
        var _subdir_path = this.state.subdir.value;
        if (_subdir_path && _subdir_path.length > 0 && _subdir_path.startsWith(this.state.basePath)) {
          _subdir_path = _subdir_path.substring(this.state.basePath.length + 1);
        }
        if (_subdir_path.length > 0 && !_subdir_path.endsWith("/")) {
          _subdir_path += "/";
        }
        partialReference = "{".concat(vaultUtil.VTI_REFERENCE_TYPE, "::").concat(toolcardName, ".").concat(_subdir_path, "}");
      } else {
        partialReference = "{".concat(vaultUtil.VTI_REFERENCE_TYPE, "::").concat(toolcardName, "}");
      }
      var promises = [this.createFetchPartialPromise(partialReference)];

      // Check the type of the current reference if any
      var parsed = vaultUtil.parseValue(this.props.value);
      if (parsed !== null && parsed !== void 0 && parsed.toolcard && parsed.provider === vaultUtil.CRN_PROVIDER_TYPE && this.isCrnProvider((_this$state$provider4 = this.state.provider) === null || _this$state$provider4 === void 0 ? void 0 : _this$state$provider4.value)) {
        // Get the group for the CRN secret so that we can select the correct one from the dropdown later
        var url = "".concat(vaultUtil.SECRETS_API_PATH, "/details?reference=").concat(encodeURIComponent(this.props.value));
        var _this$props9 = this.props,
          envId = _this$props9.envId,
          accountContext = _this$props9.accountContext,
          bssAccount = _this$props9.bssAccount,
          toolchainId = _this$props9.toolchainId;
        promises.push(xhrPromise(url, {
          dataType: "json",
          method: "GET",
          env_id: envId,
          accountContext: accountContext,
          bssAccount: bssAccount,
          toolchainId: toolchainId,
          headers: _objectSpread({}, toolchainId ? {} : {
            "vti-instances": JSON.stringify(this.props.vaultIntegrations || [])
          })
        }));
      }
      Promise.allSettled(promises).then(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
          r1 = _ref3[0],
          r2 = _ref3[1];
        var result = r1 === null || r1 === void 0 ? void 0 : r1.value;
        var detailsResult = r2 === null || r2 === void 0 ? void 0 : r2.value;
        if (!cancelObj.cancel) {
          // note 404 and default_secret; might have been that don't have permission to list this path
          // or might have been an actual 404 path was not found - can't know for sure as HV server
          // response codes are vague, so try to use the default_secret and see if it allows list the secret fields
          if (result !== null && result !== void 0 && result.body && result.body.providers && result.body.providers[0] && (result.body.providers[0].secrets || result.body.providers[0].groups) && (result.body.providers[0].status === 200 || result.body.providers[0].status === 404 && !!result.body.providers[0].default_secret)) {
            // Sort the results
            var returnedOptions = _this15.state.toolcardType === vaultUtil.HV_PROVIDER_TYPE ? result.body.providers[0].secrets : result.body.providers[0].groups;
            var options = returnedOptions.map(function (item, i) {
              return {
                value: item,
                name: item,
                id: result.body.providers[0].group_ids && result.body.providers[0].group_ids[i]
              };
            }).sort(function (a, b) {
              return a.name.toLocaleLowerCase().localeCompare(b.name.toLocaleLowerCase());
            });

            // apply any custom filter...
            var secretFilter = result.body.providers[0].secret_filter;
            var HV_SECRET_FILTER_REGEX = "*";
            if (options && options.length > 0 && secretFilter && secretFilter !== HV_SECRET_FILTER_REGEX) {
              try {
                var regex = new RegExp(secretFilter, "u"); // u - Unicode
                if (regex) {
                  options = options.filter(function (item) {
                    return item.value.match(regex);
                  });
                }
                if (options.length === 0) {
                  var defaultSecret = result.body.providers[0].default_secret;
                  if (defaultSecret) {
                    options = [{
                      value: defaultSecret,
                      name: defaultSecret
                    }];
                  } else if (console.info) {
                    console.info("[SecretInput.SecretDialogFields.fetchHvSecrets] " + "The hashicorpvault secret_filter \"".concat(secretFilter, "\" has hidden all secrets"));
                  }
                }
              } catch (e) {
                if (console.warn) {
                  // [SecretInput.SecretDialogFields.fetchHvSecrets] Bad RegularExpression in
                  // hashicorpvault secret_filter "aa[" with error: Invalid regular
                  // expression: /aa[/: Unterminated character class
                  console.warn("[SecretInput.SecretDialogFields.fetchHvSecrets] " + "Bad RegularExpression in hashicorpvault secret_filter \"".concat(secretFilter, "\" with error: ").concat(e.message || e));
                }
              }
            }
            if (options && options.length > 0) {
              // Work out the initial value for the dropdown
              var value;

              // Try the value from the secretInput first
              var _parsed = vaultUtil.parseValue(_this15.props.value);
              if (_parsed && _parsed.toolcard) {
                var _this15$state$provide;
                if (_parsed.provider === vaultUtil.CRN_PROVIDER_TYPE && _this15.isCrnProvider((_this15$state$provide = _this15.state.provider) === null || _this15$state$provide === void 0 ? void 0 : _this15$state$provide.value)) {
                  var found = options.find(function (group) {
                    var _detailsResult$body;
                    return group.id === (detailsResult === null || detailsResult === void 0 || (_detailsResult$body = detailsResult.body) === null || _detailsResult$body === void 0 ? void 0 : _detailsResult$body.group);
                  });
                  value = found && found.value;
                } else {
                  var _found3 = options.find(function (group) {
                    return group.value === _parsed.group;
                  });
                  value = _found3 && _found3.value;
                }
              }
              if (!value) {
                // Try the current value next
                value = _this15.state.group.value;
                if (!options.find(function (item) {
                  return item.value === value;
                })) {
                  var _defaultSecret = result.body.providers[0].default_secret;
                  if (_defaultSecret && options.find(function (item) {
                    return item.value === _defaultSecret;
                  })) {
                    value = _defaultSecret;
                  } else {
                    value = options[0] && options[0].value;
                  }
                }
              }

              // Set the state and trigger a child fetch
              _this15.setState({
                group: {
                  state: "idle",
                  options: options,
                  value: value // Also set in callback - do here to avoid re-render
                }
              }, function () {
                return _this15.onGroupChange(value);
              });
            } else {
              var msg = _this15.state.toolcardType === vaultUtil.HV_PROVIDER_TYPE ? translations.noHvSecrets : translations.noGroups;
              _this15.setGroupError(msg);
            }
          } else {
            var _msg = _this15.state.toolcardType === vaultUtil.HV_PROVIDER_TYPE ? translations.fetchHvSecretStatusNotOk : translations.fetchGroupsError;
            _this15.setGroupError(_msg);
          }
        }
      })["catch"](function (err) {
        if (!cancelObj.cancel) {
          var msg = _this15.state.toolcardType === vaultUtil.HV_PROVIDER_TYPE ? translations.fetchSecretsError : translations.fetchGroupsError;
          _this15.setGroupError(msg);
        }
      });
    }
  }, {
    key: "fetchToolcardRefSm",
    value: function fetchToolcardRefSm() {
      // Note, the actual fetch will be done in RefResolverSecretFields,
      // this is just cancelling the fetching & promises for other fields.
      var fields = ["region", "resource_group", "instance", "subdir", "subdirHelper"];
      var fetchFields = ["group", "secret", "field"];
      this.cancelPromises([].concat(fields, fetchFields));
      // TODO For ref-sm options, not yet "fetching", to disable the ok button,
      // or use similar mechanism for RefResolverSecretFields,
      // and similarly should call onCumulativeStateChange
      this.setState(_objectSpread({}, this.getUpdatedState([].concat(fields, fetchFields), {
        state: "idle",
        error: ""
      })));
      var cancelObj = {
        cancel: false
      };
      this.promises.group = cancelObj;
    }
  }, {
    key: "fetchToolcardSubdirs",
    value: function fetchToolcardSubdirs() {
      var _this16 = this;
      var translations = this.props.i18n.messages;
      var fields = ["region", "resource_group", "instance", "field"];
      var fetchFields = ["group", "subdir", "subdirHelper", "secret"];
      this.cancelPromises([].concat(fields, fetchFields));
      if (this.state.showSubdir) {
        this.setState(_objectSpread(_objectSpread({}, this.getUpdatedState(fields, {
          state: "idle",
          error: ""
        })), this.getUpdatedState(fetchFields, {
          state: "fetching",
          error: ""
        })));
        var cancelObj = {
          cancel: false
        };
        this.promises.subdirHelper = cancelObj;

        // check if the currently set secret value
        // includes a subdirectory segment - if so use
        // this value to preset the subdir field later...
        var subdirSegment;

        // also extract the secret and field name pairs
        // for use in populating the input fields when
        // the 403/422 cases occur...
        var secretSegment;
        var fieldSegment;
        var parsed = vaultUtil.parseValue(this.props.value);
        if (parsed && parsed.toolcard && parsed.group) {
          // note: the group can be just plain secret name
          // or it can also hold the subdir path and secret name...
          subdirSegment = parsed.group;
          fieldSegment = parsed.secret;
          if (subdirSegment.includes("/")) {
            // separate the subdir path and secret name...
            var index = subdirSegment.lastIndexOf("/");
            secretSegment = subdirSegment.substring(index + 1);
            subdirSegment = subdirSegment.substring(0, index);
          } else {
            // just plain group (aka secret name)...
            secretSegment = subdirSegment;
            subdirSegment = undefined;
          }
        }
        var toolcardName = this.state.provider.value.split(":").pop();
        var partialReference = "{".concat(vaultUtil.VTI_REFERENCE_TYPE, "::").concat(toolcardName, "}");
        this.createFetchPartialPromise(partialReference, {
          listSubdirs: true
        }).then(function (result) {
          if (!cancelObj.cancel) {
            if (result.body && result.body.providers && result.body.providers[0] && result.body.providers[0].status === 200 && result.body.providers[0].path && result.body.providers[0].subdirs) {
              var basePath = result.body.providers[0].path;
              var currentSubdirectory = result.body.providers[0].subdirectory;
              var returnedOptions = result.body.providers[0].subdirs;
              var i = 0;
              var options = returnedOptions.map(function (item) {
                var _status;
                switch (item.code) {
                  case 403:
                    _status = " ".concat(translations.cannotList);
                    break;
                  case 422:
                    _status = " ".concat(translations.maximumDepth);
                    break;
                  default:
                    _status = "";
                }
                if (currentSubdirectory) {
                  return {
                    id: i++,
                    value: "".concat(basePath, "/").concat(currentSubdirectory, "/").concat(item.path),
                    name: "".concat(basePath, "/").concat(currentSubdirectory, "/").concat(item.path).concat(_status),
                    label: "".concat(basePath, "/").concat(currentSubdirectory, "/").concat(item.path).concat(_status),
                    code: item.code
                  };
                }
                return {
                  id: i++,
                  value: "".concat(basePath, "/").concat(item.path),
                  name: "".concat(basePath, "/").concat(item.path).concat(_status),
                  label: "".concat(basePath, "/").concat(item.path).concat(_status),
                  code: item.code
                };
              });
              if (currentSubdirectory) {
                if (!currentSubdirectory.includes("/")) {
                  options.push({
                    id: i++,
                    value: "".concat(basePath, "/").concat(currentSubdirectory),
                    name: "".concat(basePath, "/").concat(currentSubdirectory),
                    label: "".concat(basePath, "/").concat(currentSubdirectory),
                    code: result.body.providers[0].status
                  });
                }
              }
              var _basePathItem = {
                id: i++,
                value: basePath,
                name: basePath,
                label: basePath,
                code: result.body.providers[0].status
              };
              options.push(_basePathItem);
              options = options.sort(function (a, b) {
                return a.name.toLocaleLowerCase().localeCompare(b.name.toLocaleLowerCase());
              });

              // see if there is a matching subdir segment
              // already set in the combo...
              var value;
              var initialValue = [];
              var applySubdirSegment = false;
              if (subdirSegment) {
                // try matching a 200 code entry...
                var _value = options.find(function (subdir) {
                  return subdir.value === "".concat(basePath, "/").concat(subdirSegment) && subdir.code === 200;
                });
                // if we didn't find a matching 200 entry, then
                // lets try partial matching a non-200...
                if (!_value) {
                  _value = options.find(function (subdir) {
                    return "".concat(basePath, "/").concat(subdirSegment).startsWith(subdir.value) && subdir.code !== 200;
                  });
                  if (_value) {
                    // so we found a partial matching non-200 therefore
                    // we'll load this into the subdir field's value...
                    applySubdirSegment = true;
                  }
                }
                if (_value) {
                  value = {
                    selectedItems: [_value]
                  };
                  initialValue = [_value];
                } else {
                  // no matching subdir path found... going to
                  // load it anyhow as it could be a 403/422 case
                  // so let the group field work it out...
                  value = "".concat(basePath, "/").concat(subdirSegment);
                }
              }

              // default to the base path if no subdir segment specified...
              if (!value) {
                value = {
                  selectedItems: [_basePathItem]
                };
                initialValue = [_basePathItem];
              }
              _this16.props.onFieldChange("basePath", basePath, _this16.hasError());
              _this16.setState({
                basePath: basePath,
                subdirSegment: subdirSegment,
                secretSegment: secretSegment,
                fieldSegment: fieldSegment,
                noListOrDeny: false,
                applySubdirSegment: applySubdirSegment,
                subdirHelper: {
                  state: "idle",
                  options: options,
                  initialValue: initialValue,
                  value: value
                }
              }, function () {
                return _this16.onSubdirHelperChange(value);
              });
            } else if (result.body && result.body.providers && result.body.providers[0] && (result.body.providers[0].status === 403 || result.body.providers[0].status === 422) && result.body.providers[0].path && result.body.providers[0].reason) {
              var _basePath = result.body.providers[0].path;
              var _status;
              switch (result.body.providers[0].status) {
                case 403:
                  _status = " ".concat(translations.cannotList);
                  break;
                case 422:
                  _status = " ".concat(translations.maximumDepth);
                  break;
                default:
                  _status = "";
              }
              var _options = [{
                id: 0,
                value: _basePath,
                name: _basePath + _status,
                label: _basePath + _status,
                code: result.body.providers[0].status
              }];
              var _value2;
              if (subdirSegment) {
                // load the value of any subdir segment already
                // defined from the toolchain.yml... it could be a
                // 403/422 case so let the group field work it out...
                _value2 = {
                  selectedItems: [{
                    id: 1,
                    value: "".concat(_basePath, "/").concat(subdirSegment),
                    name: "".concat(_basePath, "/").concat(subdirSegment),
                    label: "".concat(_basePath, "/").concat(subdirSegment),
                    code: result.body.providers[0].status
                  }]
                };
              } else {
                _value2 = {
                  selectedItems: _options
                };
              }
              _this16.props.onFieldChange("basePath", _basePath, _this16.hasError());
              _this16.setState({
                basePath: _basePath,
                subdirSegment: subdirSegment,
                secretSegment: secretSegment,
                fieldSegment: fieldSegment,
                noListOrDeny: true,
                subdirHelper: {
                  state: "idle",
                  options: _options,
                  initialValue: _options,
                  value: _value2
                }
              }, function () {
                _this16.onSubdirHelperChange(_value2);
              });
            } else {
              var msg = translations.invalidSubdirsData;
              _this16.setSubdirHelperError(msg);
            }
          }
        })["catch"](function (err) {
          if (!cancelObj.cancel) {
            var msg = translations.errorRetrievingSubdirs;
            _this16.setSubdirHelperError(msg);
          }
        });
      } else {
        this.setState(this.getUpdatedState(fetchFields, {
          state: "idle"
        }));
      }
    }
  }, {
    key: "fetchToolcardSecrets",
    value: function fetchToolcardSecrets() {
      var _this17 = this;
      var translations = this.props.i18n.messages;
      var fields = ["region", "resource_group", "instance", "group", "subdir", "subdirHelper"];
      var fetchFields = ["secret", "field"];
      this.cancelPromises([].concat(fields, fetchFields));
      if (!this.state.showGroup || this.state.showGroup && this.state.group.value) {
        this.setState(_objectSpread(_objectSpread({}, this.getUpdatedState(fields, {
          state: "idle",
          error: ""
        })), this.getUpdatedState(fetchFields, {
          state: "fetching",
          error: ""
        })));
        var cancelObj = {
          cancel: false
        };
        this.promises.secret = cancelObj;
        var toolcardName = this.state.provider.value.split(":").pop();
        var partialReference;
        if (this.state.showGroup && !this.state.showSubdir) {
          partialReference = "{".concat(vaultUtil.VTI_REFERENCE_TYPE, "::").concat(toolcardName, ".").concat(this.state.group.value, "}");
        } else if (this.state.showGroup && this.state.showSubdir) {
          if (this.state.subdir && this.state.subdir.value && this.state.subdir.value !== this.state.basePath) {
            var _subdir_path = this.state.subdir.value;
            if (_subdir_path && _subdir_path.length > 0 && _subdir_path.startsWith(this.state.basePath)) {
              _subdir_path = _subdir_path.substring(this.state.basePath.length + 1);
            }
            if (_subdir_path.length > 0 && !_subdir_path.endsWith("/")) {
              _subdir_path += "/";
            }
            partialReference = "{".concat(vaultUtil.VTI_REFERENCE_TYPE, "::").concat(toolcardName, ".").concat(_subdir_path).concat(this.state.group.value, "}");
          } else {
            partialReference = "{".concat(vaultUtil.VTI_REFERENCE_TYPE, "::").concat(toolcardName, ".").concat(this.state.group.value, "}");
          }
        } else {
          partialReference = "{".concat(vaultUtil.VTI_REFERENCE_TYPE, "::").concat(toolcardName, "}");
        }
        this.createFetchPartialPromise(partialReference, {
          listSmIamCreds: true,
          listKv: true
        }).then(function (result) {
          if (!cancelObj.cancel) {
            // need to look at the status: 200 in the response (might give 404, 401 etc.)
            if (result.body && result.body.providers && result.body.providers[0] && result.body.providers[0].status === 200 && (result.body.providers[0].fields || result.body.providers[0].secrets)) {
              var returnedOptions = _this17.state.toolcardType === vaultUtil.HV_PROVIDER_TYPE ? result.body.providers[0].fields : result.body.providers[0].secrets;
              var options = returnedOptions.map(function (item) {
                if (item.name && item.secret_type) {
                  return {
                    value: item.name,
                    name: item.name,
                    secret_type: item.secret_type,
                    secret_crn: item.crn
                  };
                }
                return {
                  value: item,
                  name: item
                };
              }).sort(function (a, b) {
                return a.name.toLocaleLowerCase().localeCompare(b.name.toLocaleLowerCase());
              });
              if (options && options.length > 0) {
                // Work out the initial value for the dropdown
                var value;

                // Try the value from the secretInput first
                var parsed = vaultUtil.parseValue(_this17.props.value);
                if (parsed && parsed.toolcard) {
                  var _this17$state$provide;
                  if (parsed.provider === vaultUtil.CRN_PROVIDER_TYPE && _this17.isCrnProvider((_this17$state$provide = _this17.state.provider) === null || _this17$state$provide === void 0 ? void 0 : _this17$state$provide.value)) {
                    var found = options.find(function (secret) {
                      return secret.secret_crn === _this17.props.value;
                    });
                    value = found && found.value;
                  } else {
                    var _found4 = options.find(function (secret) {
                      return secret.value === parsed.secret;
                    });
                    value = _found4 && _found4.value;
                  }
                }
                if (!value) {
                  // Try the current value next
                  value = _this17.state.secret.value;
                  var _found5 = options.find(function (secret) {
                    return secret.value === value;
                  });
                  if (!_found5) {
                    value = options[0] && options[0].value;
                  }
                }

                // Set the state and trigger a child fetch
                _this17.setState({
                  secret: {
                    state: "idle",
                    options: options,
                    value: value // Also set in callback - do here to avoid re-render
                  }
                }, function () {
                  return _this17.onSecretChange(value);
                });
              } else {
                var msg = _this17.state.toolcardType === vaultUtil.HV_PROVIDER_TYPE ? translations.noFields : translations.noSecrets;
                _this17.setSecretError(msg);
              }
            } else {
              var _msg2 = _this17.state.toolcardType === vaultUtil.HV_PROVIDER_TYPE ? translations.fetchHvFieldStatusNotOk : translations.fetchSecretsError;
              _this17.setSecretError(_msg2);
            }
          }
        })["catch"](function (err) {
          if (!cancelObj.cancel) {
            var msg = _this17.state.toolcardType === vaultUtil.HV_PROVIDER_TYPE ? translations.fetchFieldsError : translations.fetchSecretsError;
            _this17.setSecretError(msg);
          }
        });
      } else {
        this.setState(this.getUpdatedState(fetchFields, {
          state: "idle"
        }));
      }
    }
  }, {
    key: "fetchToolcardFields",
    value: function fetchToolcardFields() {
      var _this18 = this;
      var translations = this.props.i18n.messages;
      var fields = ["region", "resource_group", "instance", "group", "subdir", "subdirHelper", "secret"];
      var fetchFields = ["field"];
      this.cancelPromises([].concat(fields, fetchFields));
      if (!this.state.showGroup || this.state.showGroup && this.state.group.value) {
        this.setState(_objectSpread(_objectSpread({}, this.getUpdatedState(fields, {
          state: "idle",
          error: ""
        })), this.getUpdatedState(fetchFields, {
          state: "fetching",
          error: ""
        })));
        var cancelObj = {
          cancel: false
        };
        this.promises.field = cancelObj;
        var toolcardName = this.state.provider.value.split(":").pop();
        var partialReference = "{".concat(vaultUtil.VTI_REFERENCE_TYPE, "::").concat(toolcardName, ".").concat(this.state.group.value, ".").concat(this.state.secret.value, "}");
        this.createFetchPartialPromise(partialReference, {
          listSmIamCreds: true,
          listKv: true
        }).then(function (result) {
          if (!cancelObj.cancel) {
            // need to look at the status: 200 in the response (might give 404, 401 etc.)
            if (result.body && result.body.providers && result.body.providers[0] && result.body.providers[0].status === 200 && result.body.providers[0].fields) {
              var returnedOptions = result.body.providers[0].fields;
              var options = returnedOptions.map(function (item) {
                return {
                  value: item,
                  name: item
                };
              }).sort(function (a, b) {
                return a.name.toLocaleLowerCase().localeCompare(b.name.toLocaleLowerCase());
              });
              if (options && options.length > 0) {
                // Work out the initial value for the dropdown
                var value;

                // Add the entire secret option
                options.unshift({
                  value: "",
                  name: translations.entireSecret
                });

                // Try the value from the secretInput first
                var parsed = vaultUtil.parseValue(_this18.props.value);
                if (parsed && parsed.toolcard) {
                  var found = options.find(function (field) {
                    return field.value === parsed.field;
                  });
                  value = found && found.value;
                }
                if (!value) {
                  // Try the current value next
                  value = _this18.state.field.value;
                  var _found6 = options.find(function (field) {
                    return field.value === value;
                  });
                  if (!_found6) {
                    value = options[0] && options[0].value;
                  }
                }

                // Set the state and trigger a child fetch
                _this18.setState({
                  field: {
                    state: "idle",
                    options: options,
                    value: value // Also set in callback - do here to avoid re-render
                  }
                }, function () {
                  return _this18.onFieldChange(value);
                });
              } else {
                _this18.setFieldError(translations.noKeys);
              }
            } else {
              _this18.setFieldError(translations.fetchKeysError);
            }
          }
        })["catch"](function (err) {
          if (!cancelObj.cancel) {
            _this18.setFieldError(translations.fetchKeysError);
          }
        });
      } else {
        this.setState(this.getUpdatedState(fetchFields, {
          state: "idle"
        }));
      }
    }
  }, {
    key: "setRegionError",
    value: function setRegionError(msg) {
      this.setFieldValue("region", "", {
        region: {
          state: "idle",
          error: msg
        },
        instance: _objectSpread(_objectSpread({}, this.state.instance), {}, {
          options: [],
          state: "idle"
        }),
        group: _objectSpread(_objectSpread({}, this.state.group), {}, {
          options: [],
          state: "idle"
        }),
        secret: _objectSpread(_objectSpread({}, this.state.secret), {}, {
          options: [],
          state: "idle"
        }),
        field: _objectSpread(_objectSpread({}, this.state.field), {}, {
          options: [],
          state: "idle"
        }),
        showField: false
      });
    }
  }, {
    key: "setResourceGroupError",
    value: function setResourceGroupError(msg) {
      var _this19 = this;
      this.setFieldValue("resource_group", "", {
        resource_group: {
          state: "idle",
          error: msg
        },
        instance: _objectSpread(_objectSpread({}, this.state.instance), {}, {
          options: [],
          state: "idle"
        }),
        group: _objectSpread(_objectSpread({}, this.state.group), {}, {
          options: [],
          state: "idle"
        }),
        secret: _objectSpread(_objectSpread({}, this.state.secret), {}, {
          options: [],
          state: "idle"
        }),
        field: _objectSpread(_objectSpread({}, this.state.field), {}, {
          options: [],
          state: "idle"
        }),
        showField: false
      }, function () {
        _this19.setFieldValue("resource_group_name", "", null, undefined);
      });
    }
  }, {
    key: "setProviderError",
    value: function setProviderError(msg) {
      this.setFieldValue("provider", "", _objectSpread(_objectSpread({
        provider: {
          state: "idle",
          error: msg
        }
      }, this.getUpdatedState(["region", "resource_group", "instance", "group", "secret", "field"], {
        options: [],
        state: "idle"
      })), {}, {
        showField: false
      }));
    }
  }, {
    key: "setInstanceError",
    value: function setInstanceError(msg) {
      this.setFieldValue("instance", "", _objectSpread(_objectSpread({
        instance: {
          state: "idle",
          error: msg
        }
      }, this.getUpdatedState(["group", "secret", "field"], {
        options: [],
        state: "idle"
      })), {}, {
        showField: false
      }));
    }
  }, {
    key: "setGroupError",
    value: function setGroupError(msg) {
      this.setFieldValue("group", "", _objectSpread(_objectSpread({
        group: {
          state: "idle",
          error: msg
        }
      }, this.getUpdatedState(["secret", "field"], {
        options: [],
        state: "idle"
      })), {}, {
        showField: false
      }));
    }
  }, {
    key: "setSubdirError",
    value: function setSubdirError(msg) {
      this.setFieldValue("subdir", "", _objectSpread({
        subdir: {
          state: "idle",
          error: msg
        }
      }, this.getUpdatedState(["subdirHelper", "group", "secret", "field"], {
        options: [],
        state: "idle"
      })));
    }
  }, {
    key: "setSubdirHelperError",
    value: function setSubdirHelperError(msg) {
      this.setFieldValue("subdirHelper", "", _objectSpread({
        subdirHelper: {
          state: "idle",
          error: msg
        }
      }, this.getUpdatedState(["subdir", "group", "secret", "field"], {
        options: [],
        state: "idle"
      })));
    }
  }, {
    key: "setSubdirWarning",
    value: function setSubdirWarning(msg) {
      this.setFieldValue("subdir", "", _objectSpread({
        subdir: {
          state: "idle",
          warning: msg
        }
      }, this.getUpdatedState(["subdirHelper", "group", "secret", "field"], {
        options: [],
        state: "idle"
      })));
    }
  }, {
    key: "setSubdirHelperWarning",
    value: function setSubdirHelperWarning(msg) {
      this.setFieldValue("subdirHelper", "", _objectSpread({
        subdirHelper: {
          state: "idle",
          warning: msg
        }
      }, this.getUpdatedState(["subdir", "group", "secret", "field"], {
        options: [],
        state: "idle"
      })));
    }
  }, {
    key: "setSubdirInfo",
    value: function setSubdirInfo(msg) {
      this.setFieldValue("subdir", "", _objectSpread({
        subdir: {
          state: "idle",
          info: msg
        }
      }, this.getUpdatedState(["group", "secret", "field"], {
        options: [],
        state: "idle"
      })));
    }
  }, {
    key: "setSubdirHelperInfo",
    value: function setSubdirHelperInfo(msg) {
      this.setFieldValue("subdirHelper", "", _objectSpread({
        subdirHelper: {
          state: "idle",
          info: msg
        }
      }, this.getUpdatedState(["group", "secret", "field"], {
        options: [],
        state: "idle"
      })));
    }
  }, {
    key: "setSecretError",
    value: function setSecretError(msg) {
      this.setFieldValue("secret", "", _objectSpread(_objectSpread({
        secret: {
          state: "idle",
          error: msg
        }
      }, this.getUpdatedState(["field"], {
        options: [],
        state: "idle"
      })), {}, {
        showField: false
      }));
    }
  }, {
    key: "setFieldError",
    value: function setFieldError(msg) {
      this.setFieldValue("field", "", {
        field: {
          state: "idle",
          error: msg
        }
      });
    }
  }, {
    key: "hasError",
    value: function hasError() {
      for (var property in this.state) {
        if (this.state[property] && this.state[property].error && this.state[property].error !== "") {
          return true;
        }
      }
      return false;
    }
  }, {
    key: "setFieldValue",
    value: function setFieldValue(field, value, newState, callback) {
      var _this20 = this;
      if (this.state[field]) {
        this.setState(_objectSpread(_objectSpread({}, newState || {}), {}, _defineProperty({}, field, _objectSpread(_objectSpread({}, newState && newState[field] || this.state[field]), {}, {
          value: value
        }))), function () {
          if (field === "secret") {
            _this20.props.onFieldChange("crn", _this20.getSecretCrn(value), _this20.hasError());
          }
          _this20.props.onFieldChange(field, value, _this20.hasError(), callback);
        });
      } else {
        callback && callback();
      }
    }
  }, {
    key: "setMultipleFieldsValue",
    value: function setMultipleFieldsValue(fieldNameValuePairs, callback) {
      var _this21 = this;
      var anyRelevantFields = !!Object.keys(fieldNameValuePairs).find(function (fieldName) {
        return !!_this21.state[fieldName];
      });
      if (anyRelevantFields) {
        var stateChanges = {};
        Object.entries(fieldNameValuePairs).forEach(function (_ref4) {
          var _ref5 = _slicedToArray(_ref4, 2),
            field = _ref5[0],
            value = _ref5[1];
          if (_this21.state[field]) {
            stateChanges = _objectSpread(_objectSpread({}, stateChanges), {}, _defineProperty({}, field, _objectSpread(_objectSpread({}, _this21.state[field]), {}, {
              value: value
            })));
          }
        });
        this.setState(_objectSpread({}, stateChanges), function () {
          if (Object.keys(fieldNameValuePairs).includes("secret")) {
            _this21.props.onFieldChange("crn", _this21.getSecretCrn(fieldNameValuePairs.secret), _this21.hasError());
          }
          _this21.props.onMultipleFieldsChange(fieldNameValuePairs, _this21.hasError(), callback);
        });
      } else {
        callback && callback();
      }
    }
  }, {
    key: "cancelPromises",
    value: function cancelPromises(items) {
      var _this22 = this;
      items.forEach(function (label) {
        if (_this22.promises[label]) {
          _this22.promises[label].cancel = true;
        }
      });
    }
  }, {
    key: "getUpdatedState",
    value: function getUpdatedState(names, updates) {
      var _this23 = this;
      var newState = {};
      names.forEach(function (name) {
        newState[name] = _objectSpread(_objectSpread({}, _this23.state[name]), updates);
      });
      return newState;
    }
  }, {
    key: "getSecretTypeText",
    value: function getSecretTypeText(secret_type) {
      var i18nStrings = this.props.i18n.messages;
      switch (secret_type) {
        case "iam_credentials":
          return i18nStrings.iamCredentialsType;
        case "kv":
          return i18nStrings.kvType;
        case "service_credentials":
          return i18nStrings.serviceCredentialsType;
        case "username_password":
          return i18nStrings.userCredentialsType;
        case "arbitrary":
        default:
          return i18nStrings.arbitraryType;
      }
    }
  }, {
    key: "renderDropdown",
    value: function renderDropdown(itemName, label, onChange) {
      var _this24 = this;
      var _ref6 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        helperText = _ref6.helperText;
      var item = this.state[itemName];
      var removeDropdownOptions = false;
      if (this.state.newInstance === true && this.props.mode !== "save" && (itemName === "instance" || itemName === "group" || itemName === "secret")) {
        // only Provider and some text shown, instance, group & secret combos not shown.
        removeDropdownOptions = true;
      }
      var idPrefix = this.props.idPrefix ? "".concat(this.props.idPrefix, "-") : "";
      return !removeDropdownOptions ? /*#__PURE__*/React.createElement("div", {
        className: "ocr--modal-form-section-container ocr--".concat(itemName, "-input")
      }, /*#__PURE__*/React.createElement("div", {
        className: "cds--form-item"
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: "".concat(idPrefix + itemName, "-id"),
        className: "cds--label description"
      }, label), this.state.newInstance && itemName === "instance" && this.props.mode === "save" && item.state === "idle" ? /*#__PURE__*/React.createElement("div", {
        className: "ocr--row-container"
      }, /*#__PURE__*/React.createElement("input", _extends({
        id: "".concat(idPrefix + itemName, "-id"),
        "aria-label": label
        // name={label} // Note, not using translated label in programmatic name
        ,
        placeholder: this.props.i18n.messages.instancePlaceholderText,
        className: "cds--text-input",
        value: this.state.instance.value || ""
      }, item.error ? {
        "data-invalid": true
      } : {}, {
        onChange: onChange,
        type: "text"
      })), /*#__PURE__*/React.createElement(InfoMessage, {
        info: item.info
      }), /*#__PURE__*/React.createElement(WarningMessage, {
        warning: item.warning
      }), /*#__PURE__*/React.createElement(ErrorMessage, {
        error: item.error
      })) : item.error || item.state === "fetching" ? /*#__PURE__*/React.createElement("div", {
        className: "ocr--row-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "ocr--input-with-icons-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "ocr--input-container"
      }, /*#__PURE__*/React.createElement("input", _extends({
        id: "".concat(idPrefix + itemName, "-id")
        // TODO consistency in error reporting - most others only have data-invalid:true, why these 2 extra attributes?
      }, item.error ? {
        "data-invalid": true,
        "data-show-required-tooltip": true,
        "data-isinvalid": true
      } : {}, {
        className: "cds--text-input cds--text-input--light",
        disabled: true
        // value & onChange needed to prevent browser console error:
        // react_devtools_backend.js:6 Warning: A component is changing an uncontrolled input
        // of type text to be controlled. Input elements should not switch from uncontrolled
        // to controlled (or vice versa). Decide between using a controlled or uncontrolled
        // input element for the lifetime of the component.
        // More info: https://fb.me/react-controlled-components
        ,
        value: "",
        onChange: onChange
      })), /*#__PURE__*/React.createElement("div", {
        className: "ocr--spinner-container".concat(item.state !== "fetching" ? " ocr--hidden" : "")
      }, /*#__PURE__*/React.createElement(InlineLoading, {
        className: "spinner-icon"
      })))), /*#__PURE__*/React.createElement(InfoMessage, {
        info: item.info
      }), /*#__PURE__*/React.createElement(WarningMessage, {
        warning: item.warning
      }), /*#__PURE__*/React.createElement(ErrorMessage, {
        error: item.error
      })) : /*#__PURE__*/React.createElement("div", {
        className: "cds--select"
      }, /*#__PURE__*/React.createElement("div", {
        className: "cds--select-input__wrapper"
      }, /*#__PURE__*/React.createElement("select", {
        id: "".concat(idPrefix + itemName, "-id"),
        type: "text",
        className: "cds--select-input",
        onChange: onChange,
        value: this.state[itemName].value ? this.state[itemName].value : ""
      }, item.options ? item.options.map(function (option) {
        return /*#__PURE__*/React.createElement("option", {
          className: "cds--select-option",
          key: option.value,
          value: option.value
        }, option.name && option.secret_type ? "".concat(option.name, " ").concat(_this24.getSecretTypeText(option.secret_type)) : option.name);
      }) : null), item.options && item.options.length > 0 ? /*#__PURE__*/React.createElement(ChevronDown, {
        className: "cds--select__arrow"
      }) : null), helperText ?
      /*#__PURE__*/
      // helperText like https://react.carbondesignsystem.com/?path=/story/components-select--default
      React.createElement("div", {
        className: "cds--form__helper-text"
      }, helperText) : null))) : null;
    }
  }, {
    key: "renderInput",
    value: function renderInput(itemName, label, onChange) {
      var idPrefix = this.props.idPrefix ? "".concat(this.props.idPrefix, "-") : "";
      var item = this.state[itemName];
      return /*#__PURE__*/React.createElement("div", {
        className: "ocr--modal-form-section-container ocr--".concat(itemName, "-input")
      }, /*#__PURE__*/React.createElement("div", {
        className: "cds--form-item"
      }, /*#__PURE__*/React.createElement("div", {
        className: "ocr--row-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "ocr--input-with-icons-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "ocr--input-container"
      }, /*#__PURE__*/React.createElement("label", {
        className: "cds--label",
        htmlFor: "".concat(idPrefix + itemName, "-id")
      }, label), /*#__PURE__*/React.createElement("input", _extends({
        id: "".concat(idPrefix + itemName, "-id"),
        "aria-label": label
        // name={label} // Note, not using translated label in programmatic name
        // TODO missing placeholder
        // placeholder={this.props.i18n.messages.instancePlaceholderText}
        ,
        className: "cds--text-input"
      }, item.error ? {
        "data-invalid": true
      } : {}, {
        value: this.state[itemName].value,
        onChange: onChange
      }, item.readOnly ? {
        readOnly: true
      } : {}, {
        type: "text"
      })), /*#__PURE__*/React.createElement(InfoMessage, {
        info: item.info
      }), /*#__PURE__*/React.createElement(WarningMessage, {
        warning: item.warning
      }), /*#__PURE__*/React.createElement(ErrorMessage, {
        error: item.error
      }))))));
    }
  }, {
    key: "renderNestedDropdown",
    value: function renderNestedDropdown(itemName, label, onChange) {
      var idPrefix = this.props.idPrefix ? "".concat(this.props.idPrefix, "-") : "";
      var item = this.state[itemName];
      var value = item && item.value || this.state.basePath;
      return /*#__PURE__*/React.createElement("div", {
        className: "ocr--modal-form-section-container ocr--".concat(itemName, "-input")
      }, /*#__PURE__*/React.createElement("div", {
        className: "cds--form-item"
      }, /*#__PURE__*/React.createElement("div", {
        className: "ocr--row-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "ocr--input-with-icons-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "ocr--input-container"
      }, /*#__PURE__*/React.createElement("label", {
        className: "cds--label",
        htmlFor: "".concat(idPrefix + itemName, "-id")
      }, label), /*#__PURE__*/React.createElement(NestedFilterableDropdown, {
        id: "".concat(idPrefix + itemName, "-id"),
        "aria-label": label,
        mode: "single",
        value: value,
        onChange: onChange,
        placeholder: label,
        items: item.options || [],
        initialSelectedItems: item.initialValue || []
      }), /*#__PURE__*/React.createElement(InfoMessage, {
        info: item.info
      }), /*#__PURE__*/React.createElement(WarningMessage, {
        warning: item.warning
      }), /*#__PURE__*/React.createElement(ErrorMessage, {
        error: item.error
      }))))));
    }
  }, {
    key: "renderNoIntegrationsError",
    value: function renderNoIntegrationsError() {
      var _this$props$noIntegra;
      if ((_this$props$noIntegra = this.props.noIntegrationsModal) !== null && _this$props$noIntegra !== void 0 && _this$props$noIntegra.error) {
        return /*#__PURE__*/React.createElement("div", {
          className: "ocr--warning-container-no-integrations"
        }, /*#__PURE__*/React.createElement(WarningAlt, {
          className: "ocr--warning-icon",
          size: "20"
        }), this.props.noIntegrationsModal.error);
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "ocr--warning-container-no-integrations"
      }, /*#__PURE__*/React.createElement(WarningAlt, {
        className: "ocr--warning-icon",
        size: "20"
      }), /*#__PURE__*/React.createElement(FormattedHTMLMessage, {
        id: "noIntegrationsWarning",
        values: {
          toolchainId: this.props.toolchainId,
          envId: this.props.envId
        }
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state$provider5,
        _this$state$provider6,
        _this25 = this;
      var _this$props0 = this.props,
        className = _this$props0.className,
        mode = _this$props0.mode;
      var translations = this.props.i18n.messages;
      var groupLabel = this.state.toolcardType === vaultUtil.HV_PROVIDER_TYPE ? translations.secretName : translations.groupName;
      var secretLabel = this.state.toolcardType === vaultUtil.HV_PROVIDER_TYPE ? translations.labelField : translations.secretName;
      var subdirHelperLabel = translations.subdirHelperLabel;
      var subdirInputLabel = this.state.toolcardType === vaultUtil.HV_PROVIDER_TYPE && !this.state.noListOrDeny ? translations.subdirInputLabel : translations.subdirInputLabelEditMode;
      var noProviderLabel = this.state.provider.value === vaultUtil.KP_PROVIDER_TYPE ? translations.noProviderInstances : translations.noSmProviderInstances;

      // TODO translate
      var providerHelperText = this.state.toolcardType === vaultUtil.SM_PROVIDER_TYPE && (_this$state$provider5 = this.state.provider) !== null && _this$state$provider5 !== void 0 && _this$state$provider5.value && ((_this$state$provider6 = this.state.provider) === null || _this$state$provider6 === void 0 || (_this$state$provider6 = _this$state$provider6.options.find(function (e) {
        return e.value === _this25.state.provider.value;
      })) === null || _this$state$provider6 === void 0 ? void 0 : _this$state$provider6.smToolcardUiMode) === "sm-legacy" ? this.props.i18n.messages.usingLegacyDialog : undefined;
      return /*#__PURE__*/React.createElement("div", {
        className: className
      }, this.props.noIntegrations ? this.renderNoIntegrationsError() : /*#__PURE__*/React.createElement(React.Fragment, null, this.renderDropdown("provider", translations.provider, this.onProviderChange, {
        helperText: providerHelperText
      }), !this.state.toolcardType && this.state.provider.state !== "fetching" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "ocr--modal-split-row-container"
      }, this.renderDropdown("region", translations.region, this.onRegionChange), this.renderDropdown("resource_group", translations.resourceGroup, this.onResourceGroupChange)), this.renderDropdown("instance", translations.serviceName, this.onInstanceChange)) : null, this.state.showSubdir && this.state.provider.state !== "fetching" ? /*#__PURE__*/React.createElement(React.Fragment, null, this.renderNestedDropdown("subdirHelper", subdirHelperLabel, this.onSubdirHelperChange), this.renderInput("subdir", subdirInputLabel, this.onSubdirChange)) : null, this.state.showGroup && this.state.provider.state !== "fetching" ? mode === "save" && this.state.toolcardType === vaultUtil.HV_PROVIDER_TYPE ? this.renderInput("group", groupLabel, this.onGroupChange) : this.state.showSubdir && this.state.noListOrDeny ? this.renderInput("group", groupLabel, this.onNoListOrDenyGroupChange) : this.state.toolcardType === vaultUtil.REF_SM_PROVIDER_TYPE ? /*#__PURE__*/React.createElement(RefResolverSecretFields, {
        onMultipleFieldsChange: this.props.onMultipleFieldsChange,
        envId: this.props.envId,
        accountContext: this.props.accountContext,
        bssAccount: this.props.bssAccount,
        toolchainId: this.props.toolchainId,
        vaultIntegrations: this.props.vaultIntegrations,
        idPrefix: this.props.idPrefix,
        i18n: this.props.i18n,
        mock: this.props.mock,
        instanceIntegrationName:
        // toolcardName
        this.state.provider.value.split(":").pop(),
        initialReference: this.props.value
      }) : this.renderDropdown("group", groupLabel, this.onGroupChange) : null, this.state.provider.state !== "fetching" && this.state.toolcardType !== vaultUtil.REF_SM_PROVIDER_TYPE ? mode === "save" ? this.renderInput("secret", secretLabel, this.onSecretChange) : this.state.toolcardType === vaultUtil.HV_PROVIDER_TYPE && this.state.showSubdir && this.state.noListOrDeny ? this.renderInput("secret", secretLabel, this.onNoListOrDenySecretChange) : this.renderDropdown("secret", secretLabel, this.onSecretChange) : null, this.state.showField && this.state.provider.state !== "fetching" ? mode === "save" ? null : this.renderDropdown("field", translations.labelKey, this.onFieldChange) : null, mode === "retrieve" && this.state.newInstance === true && this.state.provider.state !== "fetching" ? /*#__PURE__*/React.createElement("div", {
        className: "ocr--modal-description"
      }, /*#__PURE__*/React.createElement(FormattedHTMLMessage, {
        id: noProviderLabel,
        defaultMessage: noProviderLabel
      })) : null));
    }
  }]);
}(Component);
SecretDialogFields.propTypes = {
  label: PropTypes.string,
  accountContext: PropTypes.string.isRequired,
  bssAccount: PropTypes.string.isRequired,
  envId: PropTypes.string,
  mode: PropTypes.string,
  provider: PropTypes.string,
  instance: PropTypes.string,
  region: PropTypes.string,
  resource_group: PropTypes.string,
  modalOpen: PropTypes.bool,
  onFieldChange: PropTypes.func,
  onMultipleFieldsChange: PropTypes.func,
  onCumulativeStateChange: PropTypes.func,
  updateModalState: PropTypes.func,
  vaultIntegrations: PropTypes.array,
  vaultEnabled: PropTypes.bool,
  idPrefix: PropTypes.string,
  i18n: PropTypes.object.isRequired,
  toolchainId: PropTypes.string,
  toolchainName: PropTypes.string,
  secretInputName: PropTypes.string,
  onlyVtiProviders: PropTypes.bool,
  subdir: PropTypes.string,
  subdirHelper: PropTypes.string,
  mock: PropTypes.bool,
  keyCreationType: PropTypes.string
};
SecretDialogFields.defaultProps = {
  label: "",
  idPrefix: "",
  mock: false,
  vaultEnabled: false
};
export default SecretDialogFields;